import { render } from "./LayoutsAuthMobileFooter.vue?vue&type=template&id=202516ea&ts=true"
import script from "./LayoutsAuthMobileFooter.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthMobileFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__